
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.17 2.645A8.1 8.1 0 112.733 14.79a1 1 0 00-1.63 1.158A10.1 10.1 0 102.165 2.99L1.993 1.59a1 1 0 10-1.985.244l.469 3.813a1 1 0 001.07.875l3.82-.294a1 1 0 10-.153-1.994l-1.589.123A8.1 8.1 0 016.17 2.645z"}})])
          )
        }
      }
    